import TeamRankingView from './TeamRankingView';

export default TeamRankingView;
